{
  "title": "Account",
  "description": "Manage your profile and identity across the platform.",
  "profileTitle": "Profile",
  "profileDescription": "Your name and email. Saving a name takes effect immediately; an email change is confirmed by a link we send to the new address.",
  "firstNameLabel": "First name",
  "lastNameLabel": "Last name",
  "emailLabel": "Email address",
  "emailHint": "Used for sign-in and account notifications.",
  "save": "Save changes",
  "sendVerification": "Send verification link",
  "saved": "Saved",
  "savedDescription": "Your profile has been updated.",
  "saveError": "We couldn't save your changes.",
  "saveErrorDescription": "Try again, and if it keeps happening, contact support.",
  "emailSent": "Check your inbox",
  "emailSentDescription": "We sent a link to {{email}} to confirm the change.",
  "emailError": "We couldn't start the email change.",
  "emailUnchanged": "That's already your email address.",
  "identityTitle": "Identity",
  "identityDescription": "Your status and roles on this account.",
  "statusLabel": "Account status",
  "rolesLabel": "Roles",
  "tenantLabel": "Organization",
  "platformTenant": "Platform",
  "validation": {
    "firstNameRequired": "Enter your first name.",
    "lastNameRequired": "Enter your last name.",
    "nameTooLong": "Use 100 characters or fewer.",
    "emailRequired": "Enter an email address.",
    "emailInvalid": "Enter a valid email address."
  }
}
